import MoreInfo from '@/components/MoreInfo';
import { warehouseStatisticsData } from '../cooperateData';

export default function WarehouseStatistics() {
  return (
    <section className="bg-primary-10 desktop:py-16 py-12">
      <div className="max-w-8xl desktop:px-8 mx-auto flex flex-col items-center justify-center px-4">
        <article className="desktop:space-y-4 flex-col space-y-3">
          <h2 className="text-title32 text-neutral-90 desktop:text-title42 text-center font-bold">
            Ahamove cam kết mang đến dịch vụ ưu việt
          </h2>
          <p className="text-body14 text-neutral-60 desktop:text-subtitle18 desktop:font-semibold text-center font-normal">
            Đem đến trải nghiệm hoàn toàn mới trong thị trường giao hàng nội
            thành tại Hồ Chí Minh và Hà Nội
          </p>
        </article>
        <div className="desktop:grid-cols-3 desktop:gap-x-40 desktop:gap-y-12 grid grid-cols-1 py-12">
          {warehouseStatisticsData.map((item) => (
            <article
              key={item.id}
              className="bg-primary-10 mx-2 rounded-2xl p-6"
            >
              <div className="flex h-full flex-col items-start justify-start">
                <p className="text-title32 text-primary-50 font-bold">
                  {item.title}
                </p>
                <p className="text-subtitle18 text-neutral-60 desktop:font-semibold mt-1 font-normal">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
        <MoreInfo
          title="Xem thêm chính sách dịch vụ"
          type="secondary"
          href="/"
        />
      </div>
    </section>
  );
}
